export interface IErrorItem {
  headline: string;
  img: string;
  code: string;
  errorMessage: string;
}

export const ERROR_CODE_DEFAULT = 'default';
export interface IClickToCallMeData {
  clicktocall: {
    toSubmit: {
      title: string;
      description: string;
      descriptionCallMeNow: string;
      phoneNumber: string;
      callMeBack: string;
      contactTime: string;
      buttonLabel: string;
      footer: string;
      moreText: string;
    };
    successSubmission: {
      img: string;
      imgMobile: string;
      headline: string;
      message: string;
      messageCallMeNow: string;
    };
    errorSubmission: Array<IErrorItem>;
  };
}

export interface ICmsAppClickToCallChoice {
  title?: string;
  description?: string;
  activeLabel?: string;
  cancelLabel?: string;
}
